import type { IconNode } from '../types';

/**
 * @name hiking-stick
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTMuNSAxMC41IDIgMjIiIC8+CiAgPHBhdGggZD0iTTE2LjM1MiAxMS42NDhhMS4yMDUgMS4yMDUgMCAwMS0xLjcwNCAwbC0yLjI5Ni0yLjI5NmExLjIwNSAxLjIwNSAwIDAxMC0xLjcwNGwuNzItLjcyYTIgMiAwIDAxMS4wMjItLjU0NmwuNTk5LS4xMmEyIDIgMCAwMDEuNTY5LTEuNTdsLjEyLS41OThhMiAyIDAgMDEuNTQ2LTEuMDIybC43Mi0uNzJhMS4yMDUgMS4yMDUgMCAwMTEuNzA0IDBsMi4yOTYgMi4yOTZhMS4yMDUgMS4yMDUgMCAwMTAgMS43MDRsLTYuMDIgNi4wMmExIDEgMCAxMDMgM2wuMjAxLS4yMDFBNy40IDcuNCAwIDAwMjEgOS45M1Y3IiAvPgogIDxwYXRoIGQ9Im02IDIxLTMtMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/hiking-stick
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const HikingStick: IconNode = [
  ['path', { d: 'M13.5 10.5 2 22' }],
  [
    'path',
    {
      d: 'M16.352 11.648a1.205 1.205 0 01-1.704 0l-2.296-2.296a1.205 1.205 0 010-1.704l.72-.72a2 2 0 011.022-.546l.599-.12a2 2 0 001.569-1.57l.12-.598a2 2 0 01.546-1.022l.72-.72a1.205 1.205 0 011.704 0l2.296 2.296a1.205 1.205 0 010 1.704l-6.02 6.02a1 1 0 103 3l.201-.201A7.4 7.4 0 0021 9.93V7',
    },
  ],
  ['path', { d: 'm6 21-3-3' }],
];

export default HikingStick;
